/**
 * @module Upload
 */
import {getField, updateField} from 'vuex-map-fields';
import {mixin} from "../../helpers/helper";

export default {
    mixins: [mixin],
    namespaced: true,
    state: {
        formData: {
            description: '',
            fileName: '',
            id: 0,
        },
        fileData: [],
        myErrors: [],

    },
    getters: {
        getField
    },
    mutations: {
        updateField,
        clearFormModalUpload: function(state)
        {
            state.formData.description =  ' ';
            state.formData.fileName = '';
            state.formData.id = 0;
        },

        myErrorsSet: function (state, data) {
            state.myErrors = data;
            console.log('errors...', state.myErrors);
        },
    },
    actions: {
        /**
         * using EveryWhere
         * @param state
         * @param error
         */
        handleError: function (state, error) {
            if (error.response.status == 401) {
                state.dispatch('user/checkErrorMessage', error.response, {root: true});
            }
            else {
                state.commit('myErrorsSet', error.response.data.errors);
            }
        },

        settingFileData: function(state, data)
        {
            state.state.formData.description = data.descrizione;
            state.state.formData.fileName = data.nome_file;
            state.state.formData.id = data.id;
        },

        clearFormData: function(state)
        {
            state.commit('clearFormModalUpload');
        }

    }
}